'use client';

import { useState, useEffect } from 'react';
import { Drawer } from 'antd';
import { SettingOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import 'antd/dist/reset.css'; // 引入 antd 的样式重置文件
import PlatformSpecificModal from './platform-specific-modal';
import { getCurrentUser } from '../../services/authService';
import githubPng from '../../styles/images/github.png';
import figmaPng from '../../styles/images/figma.png';
import zhihuPng from '../../styles/images/zhihu.png';
import rednotePng from '../../styles/images/rednote.png';
import tiktokPng from '../../styles/images/tiktok.png';
import officalAccountPng from '../../styles/images/offical_account.png';
import bilibiliPng from '../../styles/images/bilibili.png';
import jikePng from '../../styles/images/jike.png';
import wechatPng from '../../styles/images/wechat.png';
import weiboPng from '../../styles/images/weibo.png';
import { drawerStyles } from '../../styles/components/social/SocialDrawer.styles';

// 社交平台数据
// 注意：这里的图标是使用占位符生成的，您可以替换为您自己的图片链接。
const platforms = [
  { name: '微信', icon: wechatPng },
  { name: '微信公众号', icon: officalAccountPng },
  { name: '知乎', icon: zhihuPng },
  { name: 'FIGMA', icon: figmaPng },
  { name: '小红书', icon: rednotePng },
  { name: '抖音', icon: tiktokPng },
  { name: 'GITHUB', icon: githubPng },
  { name: '微博', icon: weiboPng },
  { name: 'BILIBILI', icon: bilibiliPng },
  { name: '即刻', icon: jikePng },
];

const SocialDrawer = ({ visible, onClose, onSuccess }) => {
  const [modalVisible, setModalVisible] = useState(false);
  const [selectedPlatform, setSelectedPlatform] = useState(null);
  const navigate = useNavigate();
  const [currentUser, setCurrentUser] = useState(null);

  useEffect(() => {
    if (visible) {
      setCurrentUser(getCurrentUser());
    }
  }, [visible]);

  const getUserId = (user) => user?.id || user?.user_id;

  const navigateToPersonalPage = () => {
    const user = currentUser || getCurrentUser();
    const userId = getUserId(user);

    if (!userId) return false;

    navigate(`/personal-info/${userId}`);
    onClose?.();
    return true;
  };

  const handlePlatformClick = (platformName) => {
    setSelectedPlatform(platformName);
    setModalVisible(true);
    onClose(); // 关闭抽屉
  };

  const handlePersonalPageClick = () => {
    navigateToPersonalPage();
  };

  const handleModalClose = () => {
    setModalVisible(false);
    setSelectedPlatform(null);
  };

  const handleCreateSocialLinkSuccess = () => {
    onSuccess?.();
    navigateToPersonalPage();
  };

  // 单个平台选项的组件
  const PlatformItem = ({ icon, name, isCustom = false, isUser = false, avatarName, onClick }) => (
    <div
      className="flex flex-col items-center gap-2 cursor-pointer"
      onClick={onClick || (() => handlePlatformClick(name))}
    >
      {isCustom ? (
        <div className="w-14 h-14 rounded-full bg-[var(--color-primary)] flex items-center justify-center">
          <SettingOutlined className="text-2xl text-white" />
        </div>
      ) : isUser ? (
        <div className="w-14 h-14 rounded-full bg-yellow-400 flex items-center justify-center overflow-hidden border-2 border-white shadow-sm">
          {icon ? (
            <img src={icon} alt={name} className="w-full h-full object-cover" />
          ) : (
            <span className="text-white text-xl font-bold">
              {(avatarName || name)?.charAt(0)?.toUpperCase() || 'U'}
            </span>
          )}
        </div>
      ) : (
        <img
          src={icon || '/placeholder.svg'}
          alt={name}
          className="w-14 h-14 rounded-xl"
        />
      )}
      <span className="text-xs text-gray-600">{name}</span>
    </div>
  );

  return (
    <>
      <Drawer
        title="选择社交平台"
        open={visible}
        onClose={onClose}
        placement="bottom"
        height={180}
        styles={drawerStyles}
      >
        <div className="grid gap-8 gap-y-6 grid-cols-[repeat(auto-fill,minmax(80px,1fr))]">
          {platforms.map((platform) => (
            <PlatformItem
              key={platform.name}
              icon={platform.icon}
              name={platform.name}
            />
          ))}
          <PlatformItem 
            name="个人主页" 
            isUser 
            icon={currentUser?.avatar || currentUser?.avatar_url}
            avatarName={currentUser?.name}
            onClick={handlePersonalPageClick}
          />
          <PlatformItem name="自定义" isCustom />
        </div>
      </Drawer>

      <PlatformSpecificModal
        platform={selectedPlatform}
        open={modalVisible}
        onClose={handleModalClose}
        onSuccess={handleCreateSocialLinkSuccess}
      />
    </>
  );
};

export default SocialDrawer;
